export const ServiceModalConstant = {
    // 모달 표시/숨김
    SHOW_MODAL: 'SM_SHOW_MODAL',
    HIDE_MODAL: 'SM_HIDE_MODAL',

    // 미처리 알림 조회
    GET_PENDING_ALERTS: 'SM_GET_PENDING',
    GET_PENDING_ALERTS_SUCCESS: 'SM_GET_PENDING_SUCCESS',
    GET_PENDING_ALERTS_FAIL: 'SM_GET_PENDING_FAIL',

    // 알림 처리
    PROCESS_ALERT: 'SM_PROCESS_ALERT',
    PROCESS_ALERT_SUCCESS: 'SM_PROCESS_ALERT_SUCCESS',
    PROCESS_ALERT_FAIL: 'SM_PROCESS_ALERT_FAIL',

    // 큐 탐색
    NAVIGATE_PREV: 'SM_NAVIGATE_PREV',
    NAVIGATE_NEXT: 'SM_NAVIGATE_NEXT',

    // WebSocket 이벤트 수신
    WS_ISSUE_ALERT: 'SM_WS_ISSUE_ALERT',
    WS_NEW_TICKET: 'SM_WS_NEW_TICKET',
    WS_ALERT_RESOLVED: 'SM_WS_ALERT_RESOLVED',

    // 사용자 가용성
    GET_ASSIGNEE_AVAILABILITY: 'SM_GET_AVAILABILITY',
    GET_ASSIGNEE_AVAILABILITY_SUCCESS: 'SM_GET_AVAILABILITY_SUCCESS',

    // Issue Manager 설정
    GET_ISSUE_MANAGERS: 'SM_GET_MANAGERS',
    GET_ISSUE_MANAGERS_SUCCESS: 'SM_GET_MANAGERS_SUCCESS',
    GET_ISSUE_MANAGERS_FAIL: 'SM_GET_MANAGERS_FAIL',
    SET_ISSUE_MANAGERS: 'SM_SET_MANAGERS',
    SET_ISSUE_MANAGERS_SUCCESS: 'SM_SET_MANAGERS_SUCCESS',

    // 로딩
    LOADING: 'SM_LOADING',
    LOADED: 'SM_LOADED',
};
